import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from './getFilters';

export const getMinPrice = createSelector(getFilters, state => state.minPrice);

export const getMaxPrice = createSelector(getFilters, state => state.maxPrice);
